import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { HandleErrorsService, UsersService } from '../app-services';

export const userDetailsResolver: ResolveFn<unknown> = route => {
  const usersService = inject(UsersService);
  const handleErrors = inject(HandleErrorsService);
  const router = inject(Router);

  return usersService.getUserById(+route.params['id']).pipe(
    map(res => ({
      ...res.data,
      allowedPPF: Number(res.data.allowedPPF).toFixed(2),
      allowedWindows: Number(res.data.allowedWindows).toFixed(2),
    })),
    catchError(err => {
      handleErrors.handleErrors(err);
      router.navigate(['/users-management']);

      return throwError(() => err);
    }),
  );
};
